import Slider from "react-slick"
import { formatMoney } from "~/utils/formatMoney"
import SummaryStat from "~/components/Admin/Reports/SummaryStat"

const PaymentsSummarySection = ({ summary, camp, isMobile }) => {
  const summaryStatItems = [
    <SummaryStat
      key="total"
      label="Total Amount Received"
      value={`${summary ? formatMoney(summary.total_paid, camp?.currency) : "0.00"}`}
    />,
    <SummaryStat
      key="taxes"
      label="Taxes Collected"
      value={`${summary ? formatMoney(summary.total_taxes, camp?.currency) : "0.00"}`}
    />,
  ]

  const paymentSliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    pauseOnFocus: true,
  }

  return (
    <div className="pt-2 pb-2 sticky top-0 z-[0] bg-white">
      {isMobile ? (
        <div className="w-full py-2 mb-4">
          <Slider {...paymentSliderSettings}>
            {summaryStatItems.map((item, index) => (
              <div key={index} className="px-2">
                {item}
              </div>
            ))}
          </Slider>
        </div>
      ) : (
        <div className="flex flex-wrap gap-4">{summaryStatItems}</div>
      )}
    </div>
  )
}

export default PaymentsSummarySection
